import React from 'react';
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import Box from '@mui/material/Box';
import { ClickAwayListener, Popper, Paper, MenuList} from '@mui/material'
import { Add } from '@mui/icons-material';
import { useLocation, useParams } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { useCompanyData } from '../contexts/DataContext';
import { useMediaQuery } from '@mui/material';
import { textClasses } from '../../shared/config';

const useStyles = makeStyles({
    menuList:{
        padding:'0px'
    },

    menuItem:{
        padding: '8px 11px',
        width: 'auto',
        color: '#000',
        height: '100%',
        "@media (max-width:992px)": {
          padding: '8px 0px',
        },
    },

  navItem:props => ({
    '&:hover':{
      color: `${props?.menuActiveFontColor} !important`
    },
  }),

  menuSubItem: props=> ({
    '&:hover':{
      color: `${props?.menuActiveFontColor} !important`,
      backgroundColor:'rgba(0,0,0,0.05)',
    },
    '&:focus':{
      color: `${props?.menuActiveFontColor} !important`,
      backgroundColor:'rgba(0,0,0,0.05)',
    },
  })
});

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    borderBottom:'1px solid #eeeeee',
    padding:'15px 30px',

    '& .MuiListItemText-primary':{
        color:'inherit',
        fontWeight:500
    }
  },
}))(MenuItem);

export default function CustomizedMenus(props) {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const anchorRef = React.useRef(null);
  const closeTimerRef = React.useRef(null);

  const { data } = useCompanyData();
  const { defaultColor, activeColor, hasActiveBorderTop, hasActiveBorder, menuFontColor, menuActiveFontColor, isMobile, index, callback } = props;
  const classes = useStyles({menuActiveFontColor});
  const location = useLocation();  
  const {id: pathId} = useParams();
  const { t, fontFamily, companyDomain, history,buttonFontSize, isRTL } = data || {};
  const url = location.pathname;
  const categories = data?.categories || [];
  var _url = new URL(window.location.href);
  var paramCategoryId = _url.searchParams.get("catId");
  const matches992 = useMediaQuery('(max-width:992px)');
  const pathname = window?.location?.pathname;
  const pathSplit = pathname?.split('/');
  const fontSizeCls = buttonFontSize && textClasses?.[buttonFontSize] ? textClasses?.[buttonFontSize] : 'normal';

  const activeCategoryId = pathSplit[pathSplit.length - 1];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  };

  const handleMouseEnter = () => {
    // Cancel any scheduled close actions
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setOpen(!open);
  };

  const mbhandleClose = (event) => {
    // Clear any existing close timers
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }

    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const allServiceRedirect = async () => {
    if(callback) callback();
    handleClose();
    history.push(companyDomain ? '/temp/services' : `/${pathId}/temp/services`);

  };

  const redirectCategory = async (categoryId) => {
    if(callback) callback();
    handleClose();
    history.push(companyDomain ? `/temp/categories/${categoryId}` : `/${pathId}/temp/categories/${categoryId}`);
  };

  const isActive = window.location.pathname.includes('/services') || window.location.pathname.includes('/categories');
  const filterCategories = paramCategoryId && categories?.length ? categories.filter(v=> v.id === paramCategoryId) : categories;

  return (
    <Box 
      mr={matches992 ? 0 : '10px'}
      style={matches992 ? {
        width:'100%',
        borderBottom:'1px solid #E5E5E5'
      }
      :
      {
        borderTop:  hasActiveBorderTop && isActive ? `4px solid ${menuActiveFontColor ? menuActiveFontColor : menuFontColor}` : '',
        borderBottom:  hasActiveBorder && isActive ? `2px solid ${menuActiveFontColor ? menuActiveFontColor : menuFontColor}` : '',
      }}
      whiteSpace="nowrap"
      id={`menu-item-${index}`}
    >
      <Button className={`${classes.menuItem}`}
       ref={anchorRef}
       aria-controls={open ? 'menu-list-grow' : undefined}
       aria-haspopup="true"
      >
        <Box
            fontWeight={500}
            onClick={matches992 ? handleMouseEnter : handleClick}
            className={`${classes.navItem} ${fontSizeCls}`}
            style={{cursor:'pointer',color: matches992 ? '#000' : isActive ? menuActiveFontColor : (menuFontColor || defaultColor)}}
        >
            {t && t('companyPage.services')}
        </Box>
        {matches992 ? <Add  style={{paddingLeft:'10px',cursor:'pointer'}} onClick={handleMouseEnter} /> : null}
      </Button>
      {matches992 ?
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1500, position: matches992 ? 'unset' : 'fixed',...(matches992 ? {...(isRTL === 'ar' ? {marginRight:'auto'} : {marginLeft:'auto'}), width:'90%'} : {}) }}>
              <Paper style={matches992 ? {boxShadow:'none'} : {}}>
                <ClickAwayListener onClickAway={mbhandleClose}>
                  <MenuList classes={{root:classes.menuList}} autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    <StyledMenuItem style={{color: pathname.includes('/temp/services') ? menuActiveFontColor : 'inherit'}} className={`${classes.menuSubItem} ${fontSizeCls}`} onClick={allServiceRedirect}>{t && t("companyPage.allServices")}</StyledMenuItem>
                    {React.Children.toArray(filterCategories.map(v=> {
                     return <StyledMenuItem className={`${classes.menuSubItem} ${fontSizeCls}`} style={{color: activeCategoryId === v?.id ? menuActiveFontColor : 'inherit'}} onClick={()=> redirectCategory(v?.id)}>{v?.name}</StyledMenuItem>;
                    }))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
        </Popper>
        :
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        classes={{list:classes.menuList}}
      >
        <StyledMenuItem style={{color: pathname.includes('/temp/services') ? menuActiveFontColor : 'inherit'}} className={`${classes.menuSubItem} ${fontSizeCls}`}>
          <ListItemText style={{fontFamily,cursor:'pointer'}} className={fontSizeCls} onClick={allServiceRedirect} primary={t && t("companyPage.allServices")} />
        </StyledMenuItem>
        {React.Children.toArray(filterCategories.map(v=> {
            return(
                <StyledMenuItem className={`${classes.menuSubItem} ${fontSizeCls}`} style={{color: activeCategoryId === v?.id ? menuActiveFontColor : 'inherit'}}>
                <ListItemText style={{
                    fontFamily:'Cairo, sans-serif',
                    cursor:'pointer',
                    textTransform:'capitalize',
                }} 
                className={fontSizeCls}
                onClick={()=> redirectCategory(v?.id)}>{v?.name}</ListItemText>
                </StyledMenuItem>
            )
        }))}
      </StyledMenu>
      }
    </Box>
  );
}